import { render, staticRenderFns } from "./flowStaff.vue?vue&type=template&id=4c5e5939&"
import script from "./flowStaff.vue?vue&type=script&lang=js&"
export * from "./flowStaff.vue?vue&type=script&lang=js&"
import style0 from "./flowStaff.vue?vue&type=style&index=0&id=4c5e5939&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports